import gql from 'graphql-tag';

export default gql`
  query GetGuest($id: ID!) {
    stakeholder(id: $id) {
      createdAt
      id
      updatedAt
      firstName
      lastName
      dob
      cellNumber
      email
      residentialAddress
      status
      role
      image {
        id
        original
        scaled
        thumbnail
      }
      visitings {
        id
        pass {
          id
          visit {
            id
            host {
              id
              firstName
              lastName
              cellNumber
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetGuest.ts